import { text as moduleText } from './text';

export const text = {
  ...moduleText,

  harvestValidationErrorMessage(
    error:
      | 'missing_garden'
      | 'missing_plant'
      | 'missing_date'
      | 'invalid_amount'
      | 'missing_weight_unit'
  ): string {
    const messages = {
      missing_garden: 'Please select a garden.',
      missing_plant: 'Please select a plant.',
      missing_date: 'Please select a date.',
      invalid_amount: 'Enter a valid amount greater than zero.',
      missing_weight_unit: 'Please select a weight unit.',
    } as const;
    return messages[error];
  },

  harvestMutationErrorMessage(error: unknown): string {
    if (error instanceof Error) {
      return error.message;
    }
    return 'Something went wrong. Please try again.';
  },
};
